import Vue from 'vue'
import Vuex from 'vuex'
import ApiModule from './modules/api'
import uiModule from './modules/ui'
import menuModule from '@/modules/ModuleAppMenu/store'
Vue.use(Vuex)

const STORE = new Vuex.Store({
  state: {
    version: ''
  },
  strict: true,
  modules: {
    ui: uiModule,
    api: ApiModule,
    menu: menuModule
  }
})

export default STORE



// WEBPACK FOOTER //
// ./src/store/index.js